var $ = require('jquery');
var Modernizr = require('Modernizr');
var helper = require('diy/util/helper');

module.exports = (function() {
    var currentPointerMode,
        POINTER_MODE_CLICK = 'click',
        POINTER_MODE_TOUCH = 'touch',

        STORAGE_ITEM_NAME = 'diy-ui-preference' + '-' + helper.getWebsiteId(),
        POINTER_MODE_KEY_NAME = 'pointerMode',
        preferences = null;

    var getPreferences = function() {
        var sData = localStorage.getItem(STORAGE_ITEM_NAME);

        if (sData === null) {
            return {};
        }

        return $.parseJSON(sData);
    };

    var setPreference = function(name, value) {
        preferences[name] = value;

        localStorage.setItem(STORAGE_ITEM_NAME, $.toJSON(preferences));
    };

    var getPreference = function (name) {
        return preferences[name];
    };

    var getSavedPointerMode = function() {
        return getPreference(POINTER_MODE_KEY_NAME);
    };

    var setPointerMode = function (value) {
        if (!validatePointerMode(value)) {
            throw new Error("Pointer mode " + value + " not valid");
        }

        if (value !== getSavedPointerMode()) {
            setPreference(POINTER_MODE_KEY_NAME, value);
            initPointerMode();
        }
    };

    var isPointerModeTouch = function() {
        return currentPointerMode === POINTER_MODE_TOUCH;
    };

    var validatePointerMode = function(pointerMode) {
        switch (pointerMode) {
            case POINTER_MODE_CLICK:
            case POINTER_MODE_TOUCH:
                return true;
            default:
                return false;
        }
    };

    var initPointerMode = function() {
        var savedPointerMode = getSavedPointerMode();

        if (validatePointerMode(savedPointerMode)) {
            currentPointerMode = savedPointerMode;
        } else {
            currentPointerMode = Modernizr.touch ? POINTER_MODE_TOUCH : POINTER_MODE_CLICK;
        }
    };

    var init = function() {
        //STORAGE_ITEM_NAME += '-' + helper.getWebsiteId();
        preferences = getPreferences();

        initPointerMode();

        if (isPointerModeTouch()) {
            $('html').addClass('diy-ui-interaction-touch');
        } else {
            $('html').addClass('diy-ui-interaction-click');
        }
    };

    return {
        init: init,
        isPointerModeTouch: isPointerModeTouch,
        TOUCH_POINTER_MODE: POINTER_MODE_TOUCH,
        CLICK_POINTER_MODE: POINTER_MODE_CLICK,
        setPointerMode: setPointerMode
    };
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/uiPreference/UiPreference.js
 ** module id = 884
 ** module chunks = 0
 **/